'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('redux-form/immutable');

var _Input = require('@sitebase/ui-kit/es/Input');

var _Input2 = _interopRequireDefault(_Input);

var _select = require('@sitebase/ui-kit/es/select');

var _LayoutContext = require('../LayoutContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * checks the error status of the field
 * @param  {bool}   pristine true if form was not changed
 * @param  {bool}   touched  true if field was not changed
 * @param  {bool}   active   true if field as focus
 * @param  {string} initial  the field's initial value (if any)
 * @param  {string} error    the field's error message (if any)
 * @return {bool} true if field in an error status, false otherwise
 */
var getErrorStatus = function getErrorStatus(pristine, touched, active, initial, error) {
  return (!pristine || touched || initial) && error;
};

/**
 * checks the success status of the field
 * @param  {bool}   touched  true if field was not changed
 * @param  {bool}   active   true if field as focus
 * @param  {bool}   isErrorStatus true if the field has an error status
 * @return {bool} true if the field is in a success status, false otherwise
 */
var getSuccessStatus = function getSuccessStatus(touched, active, isErrorStatus) {
  return touched && (!active || !isErrorStatus);
};

/**
 * Input group component
 * @param {FieldPropsType} param0 The field props
 * @returns {React.Element<*>} React element
 */
var renderInput = function renderInput(_ref) {
  var input = _ref.input,
      inputmode = _ref.inputmode,
      label = _ref.label,
      type = _ref.type,
      hintText = _ref.hintText,
      placeholder = _ref.placeholder,
      currency = _ref.currency,
      tabIndex = _ref.tabIndex,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      pristine = _ref$meta.pristine,
      error = _ref$meta.error,
      active = _ref$meta.active,
      initial = _ref$meta.initial;

  var isErrorStatus = getErrorStatus(pristine, touched, active, initial, error);
  var isSuccessStatus = getSuccessStatus(touched, active, isErrorStatus);

  var status = null;
  if (isErrorStatus) {
    status = 'error';
  } else if (isSuccessStatus) {
    status = 'success';
  }

  var outfit = '';
  var icons = [];

  if (isErrorStatus) {
    outfit += ' error';
  } else if (isSuccessStatus) {
    outfit += ' success';
  }

  if (currency) {
    icons = [_react2.default.createElement(
      'div',
      { key: 1, className: 'qd-form-field-currency-sign' },
      currency
    )];
  }

  var inputElement = _react2.default.createElement(
    _LayoutContext.LayoutConsumer,
    null,
    function (layout) {
      if (layout === 'horizontal') {
        outfit += ' small';
      } else {
        outfit += ' large';
      }

      return _react2.default.createElement(_Input2.default, (0, _extends3.default)({
        className: 'qd-form-field-input-field',
        status: status,
        errorText: isErrorStatus ? error : null,
        floatingLabel: label,
        type: type,
        hintText: hintText,
        autoComplete: 'off',
        tabIndex: tabIndex,
        outfit: outfit,
        icons: icons,
        placeholder: placeholder,
        inputmode: inputmode
      }, input));
    }
  );

  return _react2.default.createElement(
    'div',
    { className: 'qd-form-field' },
    inputElement,
    isErrorStatus ? _react2.default.createElement(
      'div',
      { className: 'sb-input-field__error' },
      error
    ) : null
  );
};

/**
 * Select group component
 * @param {FieldPropsType} param0 The field props
 * @returns {React.Element<*>} React element
 */
var renderSelect = function renderSelect(_ref2) {
  var input = _ref2.input,
      label = _ref2.label,
      type = _ref2.type,
      _ref2$options = _ref2.options,
      options = _ref2$options === undefined ? [] : _ref2$options,
      _ref2$meta = _ref2.meta,
      touched = _ref2$meta.touched,
      error = _ref2$meta.error;
  return _react2.default.createElement(
    'div',
    { className: 'qd-form-field' },
    _react2.default.createElement(
      _select.Select,
      (0, _extends3.default)({ errorText: !!touched && !!error ? error : null, label: label, type: type }, input),
      options.map(function (el) {
        return _react2.default.createElement(
          _select.SelectOption,
          { key: el.value, value: el.value ? el.value.toString() : null },
          el.label
        );
      })
    )
  );
};

/**
 * FieldWrapper component.
 * @param {FieldWrapperPropsType} props element
 * @returns {ReactElement} React element
 * @constructor
 */
var FieldWrapper = function FieldWrapper(props) {
  var _props$id = props.id,
      id = _props$id === undefined ? '' : _props$id,
      _props$name = props.name,
      name = _props$name === undefined ? '' : _props$name,
      _props$type = props.type,
      type = _props$type === undefined ? 'text' : _props$type,
      _props$label = props.label,
      label = _props$label === undefined ? '' : _props$label,
      _props$options = props.options,
      options = _props$options === undefined ? [] : _props$options,
      _props$hintText = props.hintText,
      hintText = _props$hintText === undefined ? '' : _props$hintText,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === undefined ? '' : _props$placeholder,
      _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === undefined ? 'off' : _props$autoComplete,
      _props$autoCorrect = props.autoCorrect,
      autoCorrect = _props$autoCorrect === undefined ? 'off' : _props$autoCorrect,
      _props$isAutofocused = props.isAutofocused,
      isAutofocused = _props$isAutofocused === undefined ? false : _props$isAutofocused,
      _props$isSpellchecked = props.isSpellchecked,
      isSpellchecked = _props$isSpellchecked === undefined ? false : _props$isSpellchecked,
      onKeyDown = props.onKeyDown,
      onChange = props.onChange,
      onBlur = props.onBlur,
      _props$t = props.t,
      t = _props$t === undefined ? function () {
    return function () {};
  } : _props$t,
      _props$validate = props.validate,
      validate = _props$validate === undefined ? [] : _props$validate,
      _props$normalize = props.normalize,
      normalize = _props$normalize === undefined ? function () {} : _props$normalize,
      format = props.format,
      _props$currency = props.currency,
      currency = _props$currency === undefined ? null : _props$currency,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === undefined ? null : _props$tabIndex,
      inputmode = props.inputmode;


  if (type === 'select') {
    return _react2.default.createElement(_immutable.Field, {
      t: t,
      id: id,
      name: name,
      type: type,
      label: label,
      options: options,
      component: renderSelect,
      validate: validate,
      format: format,
      onChange: onChange,
      normalize: normalize,
      tabIndex: tabIndex
    });
  }

  return _react2.default.createElement(_immutable.Field, {
    t: t,
    id: id,
    name: name,
    type: type,
    label: label,
    component: renderInput,
    hintText: hintText,
    placeholder: placeholder,
    validate: validate,
    autoComplete: autoComplete,
    autoCorrect: autoCorrect,
    isAutofocused: isAutofocused,
    isSpellchecked: isSpellchecked,
    onKeyDown: onKeyDown,
    onChange: onChange,
    onBlur: onBlur,
    normalize: normalize,
    format: format,
    currency: currency,
    tabIndex: tabIndex,
    inputmode: inputmode
  });
};

exports.default = FieldWrapper;